import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ModuleName } from '../models/user';
import { UserService } from '../services/user.service';

type MatchMode = 'any' | 'all';

function hasAccess(userModules: ModuleName[], required: ModuleName[], mode: MatchMode) {
  if (!required.length) return true;
  return mode === 'all' ? required.every(m => userModules.includes(m)) : required.some(m => userModules.includes(m));
}

// for lazy loading
export const requireModulesMatch = (requiredModules: ModuleName[], mode: MatchMode = 'any') => {
  return () => {
    const userService = inject(UserService);
    const router = inject(Router);
    const accessDeniedPath = '/access-denied';

    return userService.getUserInfo().pipe(
      map(({ modules }) =>
        hasAccess(modules ?? [], requiredModules, mode) ? true : router.createUrlTree([accessDeniedPath])
      ),
      catchError(() => of(router.createUrlTree([accessDeniedPath])))
    );
  };
};

// for component routes
export const requireModulesActivate = (required: ModuleName[], mode: MatchMode = 'any') => {
  return () => requireModulesMatch(required, mode)();
};
